<template>
    <b-card :header-class="header_class"
            :header-bg-variant="header_bg_variant"
            :header="header"
            :header-tag="header_tag">
        <b-collapse id="card-body" v-model="visible">
            <b-card-body>
                <slot></slot>
            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
export default {
    name: "PageCard",
    props: {
        header: {
            type: String,
            default: "Default Card Header",
        },
        header_class: {
            type: String,
            default: "card-title",
        },
        header_bg_variant: {
            type: String,
            default: "navy",
        },
        header_tag: {
            type: String,
            default: "h2"
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        visible: {
            get: function() {
                return !this.loading;
            },
            set: function () {
                return false;
            }
        }
    }
}
</script>
